/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  CreateTenantRestrictionsOptions,
  CreateTenantRestrictionsStatus200,
  CreateTenantRestrictionsStatus400,
  CreateTenantRestrictionsStatus500,
} from '../types/CreateTenantRestrictions'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { createTenantRestrictions } from '../clients/createTenantRestrictions'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const createTenantRestrictionsMutationKey = () =>
  [{ url: '/v1/tenants/:tenant_id/restrictions' }] as const

export function createTenantRestrictionsMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = createTenantRestrictionsMutationKey()
  return mutationOptions<
    CreateTenantRestrictionsStatus200,
    ResponseErrorConfig<CreateTenantRestrictionsStatus400 | CreateTenantRestrictionsStatus500>,
    CreateTenantRestrictionsOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path, body }) => {
      return createTenantRestrictions({ ...config, path, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Add restrictions for tenant.
 * {@link /v1/tenants/:tenant_id/restrictions}
 */
export function useCreateTenantRestrictions<TContext>(
  options: {
    mutation?: UseMutationOptions<
      CreateTenantRestrictionsStatus200,
      ResponseErrorConfig<CreateTenantRestrictionsStatus400 | CreateTenantRestrictionsStatus500>,
      CreateTenantRestrictionsOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? createTenantRestrictionsMutationKey()

  const baseOptions = createTenantRestrictionsMutationOptions(config) as UseMutationOptions<
    CreateTenantRestrictionsStatus200,
    ResponseErrorConfig<CreateTenantRestrictionsStatus400 | CreateTenantRestrictionsStatus500>,
    CreateTenantRestrictionsOptions,
    TContext
  >

  return useMutation<
    CreateTenantRestrictionsStatus200,
    ResponseErrorConfig<CreateTenantRestrictionsStatus400 | CreateTenantRestrictionsStatus500>,
    CreateTenantRestrictionsOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    CreateTenantRestrictionsStatus200,
    ResponseErrorConfig<CreateTenantRestrictionsStatus400 | CreateTenantRestrictionsStatus500>,
    CreateTenantRestrictionsOptions,
    TContext
  >
}
